// extracted by mini-css-extract-plugin
module.exports = {"input":"NumberInput_input__E1Bsn"};